import { LenderConfiguration } from '@shared/model/lender-config.model';
import { Component, inject } from '@angular/core';
import { LenderService } from '@shared/service/lender/lender.service';
import { RoutingUrl } from '@shared/constant/route-const';
import { CommonModule, Location } from '@angular/common';
import { SharedUiLibraryModule } from '@cudirect/shared-ui-library';
import { RouterModule } from '@angular/router';

/**
 * Component representing page not found Api call
 * @Component
 */
@Component({
  selector: 'cu-404',
  templateUrl: './404.component.html',
  standalone: true,
  imports: [CommonModule, SharedUiLibraryModule, RouterModule]
})
/**
 * Class representing page not found Api call
 * @export
 * @class PageNotFoundComponent
 */
export class PageNotFoundComponent {
  public lenderData: LenderConfiguration;
  public defaultRoute = RoutingUrl.Login;
  public dashboardRoute = RoutingUrl.Dashboard;

  // Use inject pattern instead of constructor injection
  public readonly lenderService = inject(LenderService);
  private readonly location = inject(Location);

  public handleAction(): void {
    // TODO: This reloads the app, need to naviate back without destroying the entire app
    this.location.back();
  }
}
